export interface IRestrictionRulerService {

}

export const LOGIN_ACTION = 'LOGIN';
export const SHOW_MESSAGE_ACTION_TYPE = 'SHOW_MESSAGE';
export const SOF_MESSAGE_ID = 'SOF';
